export default __webpack_public_path__ + "static/media/crown3.9197dd23.png";